import config from "config";
import apiRequest from "utils/ApiRequest/apiRequest";

export const getAllActiveJMPlansReact = async ({ setExternalPlansList }) => {
  const parameters = {};
  const response = await apiRequest(
    "Packages",
    "GetAllActiveJMPlansReact",
    parameters
  );
  if (response.status === "success") {
    if (response.data) {
      setExternalPlansList(response.data);
    }
  }
};

export const getAllCodesPackagesReact = async ({ setExternalCodesList }) => {
  const parameters = {};
  const response = await apiRequest(
    "Packages",
    "GetAllCodesPackagesReact",
    parameters
  );
  if (response.status === "success") {
    if (response.data) {
      setExternalCodesList(response.data);
    }
  }
};

export const getAllCreditCardsByUserId = async ({
  setCreditCardsList,
  setDefaultToken,
  setSelectedTokenId,
  userId,
  setLoadingTokens,
  setPaymentType,
  lastPaymentInPayPal,
}) => {
  const response = await apiRequest("Users", "GetUserCreditCardsList");
  if (response.status === "success") {
    if (response.data) {
      setCreditCardsList(response.data);
      //check if there is a default token by field is_primary and take the first one
      const defaultToken = response.data.find((token) => token.is_primary);
      if (defaultToken) {
        setDefaultToken(defaultToken);
        setSelectedTokenId(defaultToken.id);
        setLoadingTokens(false);
      } else {
        //if exists credit cards get the first one
        if (response.data.length > 0) {
          setDefaultToken(response.data[0]);
          setSelectedTokenId(response.data[0].id);
        }
        setLoadingTokens(false);
        setPaymentType(lastPaymentInPayPal ? "paypal" : "creditcard");
      }
      //check if user has credit cards
      if (response.data.length <= 0) {
        setPaymentType(lastPaymentInPayPal ? "paypal" : "creditcard");
      }
    } else {
      setLoadingTokens(false);
      setPaymentType(lastPaymentInPayPal ? "paypal" : "creditcard");
    }
  }
};

export const getCouponForDisplayPopUpReact = async ({
  setCouponPopUpDetails,
  culture,
}) => {
  const parameters = {
    clientCulture: culture,
  };
  const response = await apiRequest(
    "Coupons",
    "GetCouponForDisplayPopUpReact",
    parameters
  );
  if (response.status === "success") {
    if (response.data) {
      setCouponPopUpDetails(response.data);
    }
  }
};

export const createTransactionFreeCoupon = async ({
  setLoadingProccess,
  selectedPurchase,
  isLoggedIn,
  resValidCoupon,
}) => {
  setLoadingProccess(true);
  const body = {
    TransactionUserIsAuthenticated: isLoggedIn,
    TransactionPackageName:
      selectedPurchase.packageType !== "pay-as-you-go"
        ? selectedPurchase.systemName
        : "",
    TransactionPurchaseType:
      selectedPurchase.packageType !== "pay-as-you-go"
        ? "subscription"
        : "pay-as-you-go",
    TransactionCouponCode:
      resValidCoupon !== null ? resValidCoupon.couponCode : null,
    TransactionDefaultCountry: "",
  };
  const response = await apiRequest(
    "Transactions",
    "ClientCheckoutSubmitFreeSubscriptionCouponRequestReact",
    body,
    "POST"
  );
  if (response.status === "success") {
    if (response.data && response.data.CreateFreeSubscriptionCompleteUrl) {
      window.location.href = response.data.CreateFreeSubscriptionCompleteUrl;
    }
    setLoadingProccess(false);
  } else {
    setLoadingProccess(false);
  }
};

//Create transaction
export const createTransaction = async ({
  setLoadingProccess,
  firstName,
  lastName,
  email,
  phone,
  invoiceName,
  companyId,
  totalPrice,
  selectedPurchase,
  countryToSave,
  resValidCoupon,
  purchasePaymentDetails,
  curency,
  paymentType,
  isLoggedIn,
  featureQuantity,
  selectedTokenId,
  billingCyclePrice,
  setIframePaymentURL,
  displayToast,
  setFailedPurchase,
  setCompleteStep3,
}) => {
  setLoadingProccess(true);
  const body = {
    TransactionCodesCount:
      selectedPurchase.packageType === "codes"
        ? selectedPurchase.periodType
        : 5,
    TransactionCountryId: countryToSave,
    TransactionCouponCode:
      resValidCoupon !== null ? resValidCoupon.couponCode : null,
    TransactionDefaultCountry: "",
    TransactionEmail: email,
    TransactionEncryptedMailId: null,
    TransactionFirstName: firstName,
    TransactionInvoiceId: companyId,
    TransactionInvoiceName: invoiceName,
    TransactionIsSubmitCoupon: resValidCoupon !== null ? true : false,
    TransactionLastName: lastName,
    TransactionPackageName: purchasePaymentDetails["TransactionPackageName"],
    TransactionPackagePeriod:
      selectedPurchase && selectedPurchase.periodType === "yearly" ? 12 : 1,
    TransactionPhone: phone,
    TransactionPriceDisplayedToUser: totalPrice.toString(),
    TransactionPurchaseProvider: paymentType,
    TransactionPurchaseType: purchasePaymentDetails["TransactionPurchaseType"],
    TransactionUserIsAuthenticated: isLoggedIn,
    TransactionUserPassword: null,
    getOnlyIframe: true,
    TransactionCurrency: curency,
    TransactionQuantity: featureQuantity > 0 ? featureQuantity : 1,
    token_id: selectedTokenId,
    TransactionBillingCyclePrice: billingCyclePrice,
  };
  const response = await apiRequest(
    "Transactions",
    "ClientCheckoutSubmitReact",
    body,
    "POST"
  );
  if (response.status === "success") {
    if (response.data) {
      if (response.data.PaymentPageUrl) {
        if (paymentType === "paypal" || body.token_id > 0) {
          window.location.href = response.data.PaymentPageUrl;
        } else {
          setIframePaymentURL(response.data.PaymentPageUrl);
        }
        setFailedPurchase(false);
        setLoadingProccess(false);
      } else {
        displayToast(response.data, "error");
        setLoadingProccess(false);
        setFailedPurchase(true);
        setCompleteStep3(false);
      }
    } else {
      setLoadingProccess(false);
      displayToast("purchase-global-error", "error");
      setFailedPurchase(true);
      setCompleteStep3(false);
    }
  } else {
    const textToToast = response.data ? response.data : "purchase-global-error";
    displayToast(textToToast, "error");
    setLoadingProccess(false);
    setFailedPurchase(true);
    setCompleteStep3(false);
  }
};

export const downgradeSubscription = async ({
  newPlanPeriod,
  newPlanPricePerPeriod,
  newPlanType,
  path,
  setCompleteStep3,
  displayToast,
}) => {
  const body = {
    DowngradePeriod: newPlanPeriod ? newPlanPeriod : 0,
    DowngradePlanType: newPlanType ? newPlanType : "",
    DowngradPricePerPeriod: newPlanPricePerPeriod ? newPlanPricePerPeriod : 0,
  };
  const response = await apiRequest(
    "Transactions",
    "DowngradePlans",
    body,
    "POST"
  );
  if (response.status === "success") {
    if (response.data) {
      if (response.data.GlobalSuccessStatus) {
        if (response.data.GlobalResultErrorMessage) {
          //redirect to error page
          window.location.href = response.data.GlobalResultErrorMessage;
        } else {
          //pelecard downgrade success
          const redirectURL = `${config.baseurl}${path}purchase/purchase-downgrade-success?type=${newPlanType}`;

          window.location.href = redirectURL;
        }
      } else {
        displayToast(response.data.GlobalResultErrorMessage, "error");
      }
    } else {
      displayToast("purchase-global-error", "error");
    }
  } else {
    displayToast("purchase-global-error", "error");
  }

  setCompleteStep3(false);
};

export const downgradeAddons = async ({
  addon,
  newQuantity,
  path,
  setCompleteStep3,
  displayToast,
}) => {
  const body = {
    DowngradeAddon: addon,
    DowngradeQuantity: newQuantity,
  };
  const response = await apiRequest(
    "Transactions",
    "DowngradeAddons",
    body,
    "POST"
  );
  if (response.status === "success") {
    if (response.data) {
      if (response.data.GlobalSuccessStatus) {
        //check if paypal
        //need to fix redirect if paypal cancel and addon is 0
        if (response.data.GlobalResultErrorMessage) {
          if (
            response.data.GlobalResultErrorMessage === "cancel_addon_paypal"
          ) {
            const redirectURL = `${config.baseurl}${path}purchase/purchase-downgrade-success?type=${addon}`;
            window.location.href = redirectURL;
          } else {
            window.location.href = response.data.GlobalResultErrorMessage;
          }
        } else {
          const redirectURL = `${config.baseurl}${path}purchase/purchase-downgrade-success?type=${addon}`;
          window.location.href = redirectURL;
        }
      } else {
        displayToast(response.data.GlobalResultErrorMessage, "error");
      }
    } else {
      displayToast("purchase-global-error", "error");
    }
  } else {
    displayToast("purchase-global-error", "error");
  }
  setCompleteStep3(false);
};

export const calculateSubscriptionPrice = async ({
  currency,
  packageName,
  packagePeriod,
  couponCode,
  setPrice,
  setLoadingPrice,
  setLoading,
}) => {
  setLoadingPrice(true);
  const body = {
    TransactionCurrency: currency,
    TransactionPackageName: packageName,
    TransactionPackagePeriod: packagePeriod,
    TransactionCouponCode: couponCode,
  };
  const response = await apiRequest(
    "Transactions",
    "CalculateSubscriptionPrice",
    body,
    "POST"
  );

  if (response.status === "success") {
    setPrice(response.data);
    setLoadingPrice(false);
    setLoading(false);
  }
};

export const calculateAddonsPrice = async ({
  currency,
  packageName,
  quantity,
  setPrice,
  setLoadingPrice,
  setLoading,
}) => {
  setLoadingPrice(true);
  const body = {
    TransactionCurrency: currency,
    TransactionPackageName: packageName,
    TransactionQuantity: quantity,
  };
  const response = await apiRequest(
    "Transactions",
    "CalculateAddonsPrice",
    body,
    "POST"
  );

  if (response.status === "success") {
    setPrice(response.data);
    setLoadingPrice(false);
    setLoading(false);
  }
};
